import { registerPlugin, type PluginListenerHandle } from "@capacitor/core";

export interface NativeSpeechPlugin {
  start(options: { url: string; apiUrl: string; token: string; source: string; target: string }): Promise<void>;
  stop(): Promise<void>;
  consumePendingCommand(): Promise<{ command: string | null }>;
  getDeviceStatus(): Promise<{ voiceCommandsEnabled: boolean; bluetoothConnected: boolean; audioOutputs: string[] }>;
  setVoiceCommandsEnabled(options: { enabled: boolean }): Promise<{ enabled: boolean }>;
  openAppSettings(): Promise<void>;
  addListener(event: string, listener: (data: Record<string, string>) => void): Promise<PluginListenerHandle>;
}

export const NativeSpeech = registerPlugin<NativeSpeechPlugin>("LingoSoundSpeech");

export function isStopVoiceCommand(text: string): boolean {
  const normalized = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();
  if (!normalized.includes("lingosound")) return false;
  return ["detener traduccion", "parar traduccion", "terminar traduccion", "cortar traduccion"].some((command) => normalized.includes(command));
}
